/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_Q1Inputs */

const en_guide_json_schema_faq_q1 = /** @type {(inputs: Guide_Json_Schema_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is JSON Schema hard to learn?`)
};

const ko_guide_json_schema_faq_q1 = /** @type {(inputs: Guide_Json_Schema_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 배우기 어렵나요?`)
};

const ja_guide_json_schema_faq_q1 = /** @type {(inputs: Guide_Json_Schema_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaは習得が難しいですか？`)
};

/**
* | output |
* | --- |
* | "Is JSON Schema hard to learn?" |
*
* @param {Guide_Json_Schema_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_q1 = /** @type {((inputs?: Guide_Json_Schema_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_q1(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_q1(inputs)
	return ja_guide_json_schema_faq_q1(inputs)
});